import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as runReducer from "containers/Run/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as globalReducer from "containers/App/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as datasetReducer from "containers/Home/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as tourReducer from "containers/Tour/reducer";

import EmptyNotice from "components/View/EmptyNotice";

import OptimizerRow from "components/View/Rows/OptimizerRow";

import SubView from "components/View/SubView";
import ProjectModal from "components/View/ProjectModal";

import OptimizerTile from "components/Tiles/OptimizerTile";

import { isEnabled } from "utils/featureFlags";

class RunViewContainer extends React.Component {
  handleClick(data) {
    const { history } = this.props;

    const isAdvanced = isEnabled("aible-advanced");
    const isBusiness = isEnabled("aible-business-simple");

    if (isBusiness) {
      return history.push("business/" + data.id);
    } else if (isAdvanced) {
      return history.push("project/" + data.id);
    }

    return history.push("create/" + data.id);
  }

  handleCreateProjectClick() {
    const { updateIsNewProjectModalOpen, isNewProjectModalOpen, isTourOpen, tourStep, updateTourIsOpen } = this.props;

    if (isTourOpen && tourStep == 7) {
      updateTourIsOpen(false);
    }
    updateIsNewProjectModalOpen(!isNewProjectModalOpen);
  }

  renderFirstTile() {
    const { folderEditPermission } = this.props;

    return isEnabled("aible-consumer") ? (
      <React.Fragment />
    ) : (
      <React.Fragment>
        <OptimizerTile
          isCreate
          isCreateDisabled={!folderEditPermission}
          onClick={() => this.handleCreateProjectClick()}
        />
      </React.Fragment>
    );
  }

  renderFirstRow() {
    const { updateStep, history } = this.props;

    return <div />;
  }

  getHeaders() {
    return ["Project", "Creation", "Contributors", "Subgroups", "Created By"];
  }

  handleDelete(event, id) {
    const { handleDelete } = this.props;

    event.stopPropagation();
    event.preventDefault();

    return handleDelete(id);
  }

  render() {
    const {
      isTile,
      isJobsLoading,
      data,
      pollJob,
      history,
      hProjectId,
      hideFirstTile,
      hideDelete,
      onClick,
      isOptimizersLoading,
      fetchNext,
      isConsumer
    } = this.props;

    const retData = isConsumer
      ? data
          .filter((d) => d && d.id !== hProjectId)
          .sort((a, b) => {
            if (a.segment_count && b.segment_count) {
              return b.id - a.id;
            }
            return b.segment_count - a.segment_count;
          })
      : data;

    if (isConsumer && !isOptimizersLoading && !(retData && retData.find((d) => d && d.segment_count))) {
      return (
        <EmptyNotice
          title={"No Projects Available"}
          body={
            "You don't have access to any projects right now. You will see projects once someone shares a project with you."
          }
        />
      );
    }

    return (
      <React.Fragment>
        <SubView
          {...this.props}
          label="Projects"
          headers={this.getHeaders()}
          firstTile={hideFirstTile ? <div /> : this.renderFirstTile()}
          firstRow={this.renderFirstRow()}
          fetchNext={() => fetchNext()}
          length={retData.length}
          isLoading={isOptimizersLoading}
          isInfinite={true}
          hideShowMore={false}
          renderTile={(columnIndex, style) =>
            retData && retData.length > columnIndex ? (
              isTile ? (
                <div style={style} key={columnIndex}>
                  <OptimizerTile
                    onClick={() => {
                      if (onClick) {
                        return onClick(retData[columnIndex].id);
                      }
                      const isBusiness = isEnabled("aible-business-simple");

                      if (isEnabled("aible-consumer")) {
                        return history.push("/collaborate/" + retData[columnIndex].id);
                      }
                      if (isBusiness) {
                        return history.push("/business/" + retData[columnIndex].id);
                      }
                      return history.push("/project/" + retData[columnIndex].id);
                    }}
                    handleDelete={(event) => this.handleDelete(event, retData[columnIndex].id)}
                    data={retData[columnIndex]}
                    shouldHighlight={
                      hProjectId === retData[columnIndex].id ? true : hProjectId !== undefined ? false : undefined
                    }
                    hideDelete={hideDelete}
                  />
                </div>
              ) : (
                <OptimizerRow
                  key={"optimizer-" + columnIndex}
                  project={retData[columnIndex]}
                  onClick={() => history.push("/project/" + retData[columnIndex].id)}
                />
              )
            ) : undefined
          }
          childrenLength={retData.length}
        ></SubView>
        <ProjectModal {...this.props} />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  pollJob: (jobId) => dispatch(runReducer.pollJob(jobId, true, true)),
  handleDelete: (projectId) => dispatch(projectReducer.handleDelete(projectId)),

  updateIsNewProjectModalOpen: (bool) => dispatch(viewReducer.updateIsNewProjectModalOpen(bool)),
  handleOpenBlueprint: (blueprintId) => dispatch(blueprintReducer.handleOpenBlueprint(blueprintId)),
  handleOpenDataset: (datasetId) => dispatch(blueprintReducer.handleOpenBlueprint("academic", datasetId)),
  updateCreateFromProject: (bool) => dispatch(globalReducer.updateCreateFromProject(bool)),
  updateLabel: (id, label) => dispatch(setupReducer.updateLabel(id, label)),
  getBlueprint: (bpId) => dispatch((dispatch, getState) => blueprintReducer.getBlueprint(getState(), bpId)),
  getDataset: (dsId) => dispatch((dispatch, getState) => datasetReducer.getDataset(getState(), dsId)),
  updateTransform: (id, transform) => dispatch(transformReducer.updateTransform(id, transform)),
  fetchNext: () => dispatch(projectReducer.fetchProjects()),

  updateTourIsOpen: (isOpen) => dispatch(tourReducer.updateIsOpen(isOpen))
});

const mapStateToProps = (state, ownProps) => {
  const bpId = setupReducer.getBlueprintId(state, ownProps.id);
  const selectedBlueprint = bpId !== "template" && blueprintReducer.getBlueprint(state, bpId);

  return {
    data: viewReducer.getProjects(state),
    isTile: viewReducer.getIsTile(state),
    type: viewReducer.getType(state),

    isJobsLoading: globalReducer.getIsJobsLoading(state),
    isOptimizersLoading: globalReducer.getIsOptimizersLoading(state),

    isNewProjectModalOpen: viewReducer.getIsNewProjectModalOpen(state),
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    selectedBlueprint: selectedBlueprint,
    selectedBlueprintId: bpId,

    folderEditPermission: foldersReducer.getUserEditPermission(state, foldersReducer.getSelectedFolder(state)),

    isTourOpen: tourReducer.getIsOpen(state),
    tourStep: tourReducer.getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RunViewContainer);
